import { Component,OnDestroy,OnInit } from '@angular/core';
import { AbstractModal, BroadcastService, ModalButtonModel, ModalButtonType, ToasterType } from '@cv-invision/core';
import { Store } from '@ngxs/store';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { LenderService } from '../../../service/lender.service';
import { SetFNCSettings } from '../../../state/actions/global-configuration.actions';
import { GlobalConfigurationState } from '../../../state/global-configuration.state';
import { BranchModel, DefaultSettingsModel } from '../model/fnc-default-setting.model';
import { FNCDefaultSettingService } from '../service/fnc-default-setting.service';

@Component({
    selector: 'cv-call-center-client-form',
    templateUrl: './call-center-client-form.html',
	styleUrls: ['./call-center-client-form.scss']
})

export class FNCCallCenterClientComponent extends AbstractModal implements OnInit, OnDestroy {
	private atComponentDestroy = new Subject();
    public acuityBranchSelected: Array<BranchModel>;
	public acuityLenderBranchesList: Array<BranchModel>;
	public appScopeLendersList: Array<BranchModel>;
	public clientBranchSelected: Array<BranchModel>;
	public defaultConfigModel: DefaultSettingsModel;
	public callCenterClient: DefaultSettingsModel;
	public fncClientid: string;
	public saving :boolean;

    constructor(
		 private store: Store,
		 public lenderService: LenderService,
		 private FNCDefaultSettingService: FNCDefaultSettingService,
		 private broadcastService: BroadcastService,
		 ) {
            super();
			this.callCenterClient =  new DefaultSettingsModel();
			this.defaultConfigModel = this.store.selectSnapshot(GlobalConfigurationState.getFNCSettings);
			this.acuityLenderBranchesList = this.store.selectSnapshot(GlobalConfigurationState.getAcuityLenderBranches);
			this.appScopeLendersList = this.store.selectSnapshot(GlobalConfigurationState.getAppScopeLenders);
			this.acuityBranchSelected = [];
			this.clientBranchSelected = [];
			this.saving = false;
    }

    ngOnInit() {
		if (this.data.isEditing) {
			this.callCenterClient = this.data;
			this.fncClientid = this.callCenterClient.fncClientId
			this.acuityBranchSelected = [{
				title: this.callCenterClient.defaultBranchName,
				id: this.callCenterClient.defaultBranchId
			}];
			this.clientBranchSelected = [{
				title: this.callCenterClient.defaultClientName,
				id: this.callCenterClient.defaultClientId
			}];
		}
        const saveButton: ModalButtonModel = {
			name: 'Save',
			text: 'Save',
			class: 'btn-sm cv-btn-blue',
			type: ModalButtonType.ACTION,
			disabled: (): boolean => !this.setIsFormValid() || this.saving,
			loading: (): boolean => this.saving,
			action: () => this.onSave()
		};

		const cancelButton: ModalButtonModel = {
			name: 'close',
			text: 'Close',
			class: 'btn-sm',
			type: ModalButtonType.ACTION,
			action: this.onCancel.bind(this)
		};
        this.buttons.push(cancelButton);
		this.buttons.push(saveButton);
    }

    /**
	 * on branch selected
	 * @param $event
	 */
	onBranchSelected($event: any, type: string): void {
		if ($event && type === 'acuityBranch') {
			this.callCenterClient.defaultBranchId = $event.id;
			this.callCenterClient.defaultBranchName = $event.title;
		}
		if ($event && type === 'appscopeClient') {
			this.callCenterClient.defaultClientId = $event.id;
			this.callCenterClient.defaultClientName = $event.title;
		}
		if (!$event && type === 'acuityBranch') {
			this.callCenterClient.defaultBranchId = null;
			this.callCenterClient.defaultBranchName = null;
		}
		if (!$event && type === 'appscopeClient') {
			this.callCenterClient.defaultClientId = null;
			this.callCenterClient.defaultClientName = null;
		}
	}

    /**
     * save client
     */
    onSave():void {
		const defautlSettingsCopy =  JSON.parse(JSON.stringify( this.defaultConfigModel));
		if (this.data.isEditing) {
			defautlSettingsCopy.clients.forEach( c => {
				if (c.fncClientId === this.fncClientid) {
					c.defaultBranchId =this.callCenterClient.defaultBranchId;
					c.defaultBranchName =this.callCenterClient.defaultBranchName;
					c.defaultClientId =this.callCenterClient.defaultClientId;
					c.defaultClientName =this.callCenterClient.defaultClientName;
					c.defaultAppScopeUserCreation = this.callCenterClient .defaultAppScopeUserCreation;
					c.fncClientId = this.callCenterClient.fncClientId;
				}
			});
		} else {
			defautlSettingsCopy.clients.push(this.callCenterClient);
		}

		this.FNCDefaultSettingService
			.saveFNCDefaultSettings(defautlSettingsCopy)
			.pipe(takeUntil(this.atComponentDestroy))
			.subscribe(
				() => {
					this.store.dispatch(new SetFNCSettings(defautlSettingsCopy));
					this.successHandleFunction();
					super.onAcceptSuccess({
						success: true
					});
				},
				error => {
					this.errorMsgFunction(error.error);
					super.onCancel();
				}
			);
    }

	/**
	 * Is form valid?
	 */
	 setIsFormValid(): boolean {
		const validForm = (
			   this.callCenterClient.fncClientId
			   && this.callCenterClient.fncClientId.trim().length > 0
			   && this.callCenterClient.defaultBranchId
			   && this.callCenterClient.defaultBranchId.trim().length > 0
			   &&this.callCenterClient.defaultClientId
			   && this.callCenterClient.defaultClientId.trim().length > 0
			   && this.callCenterClient.defaultAppScopeUserCreation
			   && this.callCenterClient.defaultAppScopeUserCreation.trim().length > 0
			);
		return validForm;
	}

	/**
	 * handle response from server
	 */
	 successHandleFunction(): void {
		const msg = `The Client was successfully Saved`;
		this.broadcastService.broadcast({
			name: ToasterType.SUCCESS,
			event: { message: msg }
		});
	}

	/**
	 * Display error message wheter the oparation wast´n success
	 * @param error
	 */
	errorMsgFunction(error: any): void {
		const { Error } = error;
		const event = {
			error: Error.split(':')[3].replace(/["}]/g, ''),
			autoClose: true
		};
		this.broadcastService.broadcast({
			name: ToasterType.ERROR,
			event: event
		});
	}

    onDismiss(): void {
		super.onCancel();
	}

	ngOnDestroy(): void {
		this.atComponentDestroy.next({});
		this.atComponentDestroy.unsubscribe();
	}
}